// src/components/Navbar.js
import React, { useEffect, useState, useContext } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";
import LangSwitcher from "./LangSwitcher";
import { LangContext } from "../lang/LangProvider";

/** Navbar sticky + mobile panel full-screen */
export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { lang } = useContext(LangContext);

  // Chiude menu al cambio rotta
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // Chiudi con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Blocca scroll body quando il menu è aperto
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    const prevPadding = document.body.style.paddingRight;
    if (open) {
      const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
      if (hasScrollbar) {
        const scrollBarW = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = `${scrollBarW}px`;
      }
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = prevOverflow || "";
      document.body.style.paddingRight = prevPadding || "";
    }
    return () => {
      document.body.style.overflow = prevOverflow || "";
      document.body.style.paddingRight = prevPadding || "";
    };
  }, [open]);

  return (
    <header className="af-nav" role="banner">
      <a href="#main" className="sr-only sr-only-focusable">Salta al contenuto</a>

      <div className="af-nav-inner">
        <div className="af-brand">
          <Link to={`/${lang}/`} className="af-logo" aria-label="AlphaFrame Analytics - Home">
            <span>AlphaFrame</span> <strong>Analytics</strong>
          </Link>
        </div>

        {/* Desktop */}
        <nav className="af-links" aria-label={lang === "en" ? "Main menu" : "Menu principale"}>
          <NavLink to={`/${lang}/solutions`} className="af-link">
            {lang === "en" ? "Solutions & Insights" : "Soluzioni & Insights"}
          </NavLink>
          <NavLink to={`/${lang}/tools`} className="af-link">
            {lang === "en" ? "Online Tools" : "Tool Online"}
          </NavLink>
          <NavLink to={`/${lang}/kb`} className="af-link">Knowledge Base</NavLink>
          <NavLink to={`/${lang}/series`} className="af-link">
            {lang === "en" ? "Series" : "Serie"}
          </NavLink>
          <NavLink to={`/${lang}/about`} className="af-link">
            {lang === "en" ? "About Us" : "Chi Siamo"}
          </NavLink>
          <LangSwitcher />
        </nav>

        {/* Mobile hamburger */}
        <button
          className="af-burger"
          aria-label={open ? "Chiudi menu" : "Apri menu"}
          aria-controls="af-mobile-panel"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <span className="af-burger-bar" />
          <span className="af-burger-bar" />
          <span className="af-burger-bar" />
        </button>
      </div>

      {/* Mobile panel full-viewport */}
      <div
        id="af-mobile-panel"
        className={`af-mobile ${open ? "open" : ""}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="af-mobile-content">
          <nav className="af-mobile-links" aria-label={lang === "en" ? "Mobile menu" : "Menu mobile"}>
            <NavLink to={`/${lang}/solutions`} className="af-mobile-link">
              {lang === "en" ? "Solutions & Insights" : "Soluzioni & Insights"}
            </NavLink>
            <NavLink to={`/${lang}/tools`} className="af-mobile-link">
              {lang === "en" ? "Online Tools" : "Tool Online"}
            </NavLink>
            <NavLink to={`/${lang}/kb`} className="af-mobile-link">Knowledge Base</NavLink>
            <NavLink to={`/${lang}/series`} className="af-mobile-link">
              {lang === "en" ? "Series" : "Serie"}
            </NavLink>
            <NavLink to={`/${lang}/about`} className="af-mobile-link">
              {lang === "en" ? "About Us" : "Chi Siamo"}
            </NavLink>
            <LangSwitcher />
          </nav>

          <button className="af-mobile-close" onClick={() => setOpen(false)} aria-label="Chiudi menu">
            ✕
          </button>
        </div>
      </div>
    </header>
  );
}
